import { z } from 'zod/v4';

import { SelfSignupColorsRuntype } from '../organizationSettings';

export const LoginThemeRuntype = z.object({
    primary_color: z.string().nullable(),
    page_background_color: z.string().nullable(),
    logo_url: z.string().nullable(),
});

export const PublicTenantRuntype = z.object({
    tenant: z.string(),
    organization_name: z.string(),
    terms_and_conditions_link: z.string(),
    is_self_signup_enabled: z.boolean(),
    are_private_customers_allowed: z.boolean(),
    organization_logo: z.string().nullable(),
    colors: SelfSignupColorsRuntype,
    external_auth_org_id: z.string().nullable(),
    login_theme: LoginThemeRuntype,
});

export type TenantDetails = z.infer<typeof PublicTenantRuntype>;
